export function createWishlistData({ companyId, title, description }) {
  let formData = new FormData();

  formData.append("companyId", companyId);
  formData.append("title", title);
  formData.append("description", description);

  return formData;
}
